import { Component, OnInit, Input } from '@angular/core';
import { BlogService } from '../../services/blog.service';
import { IBlogResponse } from '../../classes/interfaces';
import sortBy from 'lodash-es/sortBy';
import get from 'lodash-es/get';
import { TranslateService } from '@ngx-translate/core';
import { BlogPostSourcePage } from '../../classes/enums';

@Component({
  selector: 'app-blog-posts',
  templateUrl: './blog-posts.component.html',
  styleUrls: ['./blog-posts.component.scss']
})

export class BlogPostsComponent implements OnInit {
  @Input() sourcePage: BlogPostSourcePage = BlogPostSourcePage.HomePage;

  posts: IBlogResponse[];
  isHomePage: boolean;
  isListingPage: boolean;
  constructor(
    private blogService: BlogService,
    private translateService: TranslateService,
  ) { }

  ngOnInit() {
    const tagArray = ['cms-homepage-1', 'cms-homepage-2', 'cms-homepage-3', 'cms-listing-details-TD'];
    this.isHomePage = this.sourcePage === BlogPostSourcePage.HomePage;
    this.isListingPage = this.sourcePage === BlogPostSourcePage.ListingPage;
    this.blogService.getByTags(tagArray).toPromise()
    .then((results) => {
      if (results) {
        this.getPosts(results);
      }
    });
  }

  getPosts(results) {
    const blogPostsOnly = results.filter((obj) => obj.tag.startsWith('cms-homepage-'));
    this.posts = sortBy(blogPostsOnly, 'tag');
  }


}

